// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lUIaj","rigth_padding":"styles_rigth_padding__vEWWm","bottom_padding":"styles_bottom_padding__OLNNA","appear":"styles_appear__3MJ0j"};